import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Mainpage from "./Components/Mainpage";
import Pricacypolicy from "./Privacypolicy";
import "./App.css";
import Termsandconditions from "./Termsandconditions";
import Pngtosvg from "./Pngtosvg";
import Loader from "./Components/Loader";
import ScrollToTop from "./Components/ScrollToTop";

function AppContent() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Show loader on route change
    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); // adjust delay as needed

    return () => clearTimeout(timer);
  }, [location.pathname]); // trigger on route/path change

  if (loading) return <Loader />;

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Mainpage />} />
        <Route path="/:slug" element={<Pngtosvg />} />
        <Route path="/privacy-policy" element={<Pricacypolicy />} />
        <Route path="/terms-and-conditions" element={<Termsandconditions />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
